import { render, staticRenderFns } from "./adhibitionList.vue?vue&type=template&id=4a7cfd66&scoped=true"
import script from "./adhibitionList.vue?vue&type=script&lang=js"
export * from "./adhibitionList.vue?vue&type=script&lang=js"
import style0 from "./adhibitionList.vue?vue&type=style&index=0&id=4a7cfd66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7cfd66",
  null
  
)

export default component.exports